export default "__VITE_ASSET__C$0lHVZ3__"